import { Promise } from 'es6-promise';

const getFormData = (formData, data, previousKey = false)  => {
    if (data instanceof Object) {
        Object.keys(data).forEach(key => {
            const value = data[key];
            if (previousKey) {
                key = `${previousKey}[${key}]`;
            }
            if (value instanceof Object && !Array.isArray(value)) {
                if (!(value instanceof Date)) {
                    return getFormData(formData, value, key);
                }
            }
            if (Array.isArray(value)) {
                value.forEach(val => {
                    formData.append(`${key}[]`, val);
                });
            } else if (value instanceof Date) {
                formData.append(key, value.toISOString());
            } else if (value === null) {
                formData.append(key, ''); // enforce sending empty instead of the string "null" on some browsers
            } else {
                formData.append(key, value);
            }
        });
    }
};

function newRequest() {
    let request;
    if (window.XMLHttpRequest) { // Mozilla, Safari, ...
        request = new XMLHttpRequest();
    } else if (window.ActiveXObject) { // IE
        try {
            request = new ActiveXObject('Msxml2.XMLHTTP');
        } catch (e) {
            try {
                request = new ActiveXObject('Microsoft.XMLHTTP');
            } catch (e) {}
        }
    }

    return request;
}

function http(method, url, args, files) {

    let uri = url;
    let jsonBody;
    let request = newRequest();

    return new Promise((resolve, reject) => {
        if (args && (method === 'GET')) {
            let uriParts = [];
            for (const key in args) {
                if (args.hasOwnProperty(key) && args[key] !== null) {
                    const value = ((args[key] === true || args[key] === false) ? (args[key] ? 1 : 0) : encodeURIComponent(args[key]));
                    uriParts.push(`${encodeURIComponent(key)}=${value}`);
                }

            }
            if (uriParts.length > 0) {
                uri += `?${uriParts.join('&')}`;
            }
        }

        if (method === 'PUT' && !!files) {
            // formData only works with PUT if we actually send POST with _method: 'PUT' parameter
            request.open('POST', uri);
        } else {
            request.open(method, uri);
        }

        if (args || files) {
            switch (method) {
                case 'POST':
                case 'PUT':
                    if (!files) {
                        jsonBody = JSON.stringify(args);
                        request.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                    } else {
                        jsonBody = new FormData();
                        if (method === 'PUT') {
                            // see comment above
                            jsonBody.set('_method', 'PUT');
                        }
                        for (const key in files) if (files.hasOwnProperty(key)) {
                            const value = (files[key] === true || files[key] === false) ? (files[key] ? 1 : 0) : files[key];
                            jsonBody.append(key, value);
                        }
                        if (!!args) {
                            getFormData(jsonBody, args);
                        }
                    }
                    break;
            }
        }

        request.onload = function() {
            let json;
            if (this.responseText) {
                try {
                    json = JSON.parse(this.responseText);
                } catch (e) {
                    console.error(e, this.responseText, this);
                    json = [];
                }
            }

            if (this.status === 401) { // unauthorized, need to login
                return (window.location.href = "/login");
            } else if (this.status === 404) {
                return (reject({error: true, message: json.message || 'Not found', code: 404, data: null}));
            }


            if ((200 <= this.status) && (this.status < 300)) {
                resolve({error: false, message: '', data: json});
            } else if (this.status === 400) { // bad request (ex. a POST request with validation errors)
                reject({error: true, message: json.message, code: this.status, data: null});
            } else {
                console.error("Request %s %s has returned an error with status code %s", method, url, this.status);
                reject({error: true, message: json.message, code: this.status, data: null});
            }

        };

        request.onerror = function() {
            console.error("Request %s %s failed with status code %s", method, url, this.status);
            reject({error: true, message: `[${this.status}] ${this.responseText}`, code: this.status, data: null});
        };

        request.onabort = function() {
            console.error("Aborting request %s %s", method, url);
        };

        request.send(jsonBody);

    });
}

const Request = {
    get: (url, args) => http('GET', url, args),
    post: (url, args, files) => http('POST', url, args, files),
    put: (url, args, files) => http('PUT', url, args, files),
    delete: (url, args) => http('DELETE', url, args),
    upload: (url, files, args) => http('POST', url, args, files), // deprecated; kept for BW compatibility
};

export default Request;
